import { createAction, createSlice, PayloadAction, } from '@reduxjs/toolkit'

const prefix = 'pages/host'

export const clearStore = createAction(`${prefix}/clearStore`)

const hostSlice = createSlice({
  name: prefix,
  initialState: {
    isLoading: false as boolean,
    hostList: [] as any,
    blockedHostList: [] as any
  },
  reducers: {
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload
    },
    setHostList: (state, { payload }: PayloadAction<any>) => {
      state.hostList = payload
    },
    setBlockedHostList: (state, { payload }: PayloadAction<any>) => {
      state.blockedHostList = payload
    }
  },
  extraReducers: {
    [clearStore.type]: () => ({
      isLoading: false,
      hostList: [],
      blockedHostList: [],
    }),
  },
})

export const { setIsLoading, setHostList, setBlockedHostList } = hostSlice.actions

export const getHostList = createAction(`${prefix}/getHostList`)
export const getBlockedHostList = createAction(`${prefix}/getBlockedHostList`)
export const blockHost = createAction<{ phone: string, reason: string }>(`${prefix}/blockHost`)

export const hostReducer = hostSlice.reducer
